
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { BehaviorSubject, Subscription } from 'rxjs';
import NgtMediaRepository from '@/repositories/NgtMediaRepository';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';

@Component
export default class NgtFilmSelector extends Vue {
    @Prop({ required: false, type: String, default: '' })
    public readonly id!: string;

    @Prop({ type: Array, required: false, default: () => [] })
    public readonly rules!: ((value: any) => string | boolean)[];

    @Prop({ required: false, type: String, default: '' })
    public readonly errorMessages!: string;

    @Prop({ required: false, type: String, default: '' })
    public readonly label!: string;

    @Prop({ required: false, type: Boolean, default: false })
    public readonly disabled!: boolean;

    public search: string = '';
    public innerValue: any = null;
    public loading = true;
    public options: { id: number; label: string }[] = [];
    private valueSubject = new BehaviorSubject<number | null>(null);
    private searchSubject = new BehaviorSubject<string>('');
    private valueSubscription = new Subscription();
    private optionsSubscription = new Subscription();

    @Inject()
    private ngtMediaRepository!: NgtMediaRepository;

    @Prop({ required: false, type: Number, default: null })
    private readonly value!: number | null;

    public created(): void {
        this.valueSubscription = this.valueSubject
            .pipe(
                filter((t) => t !== this.innerValue),
                switchMap((t) => this.ngtMediaRepository.findGlossVariantByFilmId(t)),
            )
            .subscribe((currentResource) => {
                if (currentResource.isSuccess && currentResource.data) {
                    this.options = [currentResource.data];
                    this.innerValue = currentResource.data.id;
                }
            });
        this.optionsSubscription = this.searchSubject
            .pipe(
                debounceTime(300),
                distinctUntilChanged(),
                switchMap((search) => this.ngtMediaRepository.findGestureFilmsForGlossVariants(search)),
            )
            .subscribe((optionsResource) => {
                this.loading = optionsResource.isLoading;
                if (optionsResource.isSuccess && optionsResource.data) {
                    this.options = optionsResource.data;
                }
            });
    }

    public beforeDestroy(): void {
        this.valueSubscription.unsubscribe();
        this.optionsSubscription.unsubscribe();
    }

    @Watch('innerValue')
    public onInnerValueChanged(value: any) {
        this.$emit('input', value);
    }

    @Watch('value', { immediate: true })
    public onValueChanged(value: number | null) {
        this.valueSubject.next(value);
    }

    @Watch('search')
    public onSearchChanged(search: string) {
        this.searchSubject.next(search);
    }
}
